/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-console */
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useAuthContext } from "../../context/auth";
import { getEdificios } from "../../utils";
import "./stylesCotizadorProgrammaticInventario.scss";

export const CotizadorProgrammaticInventario = ({
  onSubmit,
  isProgrammaticSelected,
  resetInventario,
  onResetComplete,
  includeInstallingBuildings,
  defaultEdificios,
  defaultEdificiosAscensores,
  defaultEdificiosTotems,
  defaultEdificiosEspera,
  defaultEdificiosCowork,
}) => {
  // --- Estado primario: lista de edificios cargados ---
  const [edificios, setEdificios] = useState([]);

  // --- Estado primario: los 4 Sets de IDs (ÚNICA fuente de verdad para selección) ---
  const [edificiosSeleccionadosAscensores, setEdificiosSeleccionadosAscensores] = useState(
    new Set(defaultEdificiosAscensores ? defaultEdificiosAscensores.map(String) : [])
  );
  const [edificiosSeleccionadosTotems, setEdificiosSeleccionadosTotems] = useState(
    new Set(defaultEdificiosTotems ? defaultEdificiosTotems.map(String) : [])
  );
  const [edificiosSeleccionadosEspera, setEdificiosSeleccionadosEspera] = useState(
    new Set(defaultEdificiosEspera ? defaultEdificiosEspera.map(String) : [])
  );
  const [edificiosSeleccionadosCowork, setEdificiosSeleccionadosCowork] = useState(
    new Set(defaultEdificiosCowork ? defaultEdificiosCowork.map(String) : [])
  );

  // --- Estado UI: controles de selección ---
  const [selectAllNetwork, setSelectAllNetwork] = useState(false);
  const [selectInventory, setSelectInventory] = useState(
    defaultEdificiosAscensores?.length > 0 ||
      defaultEdificiosTotems?.length > 0 ||
      defaultEdificiosEspera?.length > 0 ||
      defaultEdificiosCowork?.length > 0
  );
  const [selectAllAscensores, setSelectAllAscensores] = useState(false);
  const [selectAllTotems, setSelectAllTotems] = useState(false);
  const [selectAllCowork, setSelectAllCowork] = useState(false);
  const [selectAllEspera, setSelectAllEspera] = useState(false);
  const [ubicacionesSeleccionadas, setUbicacionesSeleccionadas] = useState(new Set());

  // --- Estado derivado de edificios: ubicaciones y pantallas por ubicación ---
  const [ubicaciones, setUbicaciones] = useState([]);
  const [pantallasPorUbicacionMap, setPantallasPorUbicacionMap] = useState({});

  // --- Refs ---
  const hasInitializedRef = useRef(false);
  const isInitialSyncRef = useRef(true);

  const { pais, rol } = useAuthContext();

  // ===========================================
  // VALORES DERIVADOS (useMemo) — calculados automáticamente desde los Sets + edificios
  // ===========================================
  const derivedCounts = useMemo(() => {
    if (edificios.length === 0) {
      return {
        ascensoresSeleccionados: 0,
        totemsSeleccionados: 0,
        coworkSeleccionados: 0,
        esperaSeleccionados: 0,
        audienciaSeleccionadaAscensor: 0,
        audienciaSeleccionadaTotems: 0,
        audienciaSeleccionadaCowork: 0,
        audienciaSeleccionadaEspera: 0,
        audienciaSeleccionadaTotal: 0,
      };
    }

    // Helper: contar pantallas de un tipo para los edificios en un Set
    const countFor = (set, field) =>
      [...set].reduce((total, id) => {
        const edificio = edificios.find((e) => String(e.id) === id);
        return edificio ? total + (edificio[field] || 0) : total;
      }, 0);

    // Helper: contar audiencia para edificios en un Set que tienen cierto tipo de pantalla
    const audienceFor = (set, field) =>
      [...set].reduce((total, id) => {
        const edificio = edificios.find((e) => String(e.id) === id);
        return edificio && (edificio[field] || 0) > 0 ? total + (edificio.personas || 0) : total;
      }, 0);

    // Audiencia total: IDs únicos de edificios a través de todos los circuitos
    const uniqueEdificioIds = new Set([
      ...edificiosSeleccionadosAscensores,
      ...edificiosSeleccionadosTotems,
      ...edificiosSeleccionadosCowork,
      ...edificiosSeleccionadosEspera,
    ]);
    const audienciaSeleccionadaTotal = [...uniqueEdificioIds].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === id);
      return edificio ? total + (edificio.personas || 0) : total;
    }, 0);

    return {
      ascensoresSeleccionados: countFor(edificiosSeleccionadosAscensores, "pantallas"),
      totemsSeleccionados: countFor(edificiosSeleccionadosTotems, "totems"),
      coworkSeleccionados: countFor(edificiosSeleccionadosCowork, "cowork"),
      esperaSeleccionados: countFor(edificiosSeleccionadosEspera, "espera"),
      audienciaSeleccionadaAscensor: audienceFor(edificiosSeleccionadosAscensores, "pantallas"),
      audienciaSeleccionadaTotems: audienceFor(edificiosSeleccionadosTotems, "totems"),
      audienciaSeleccionadaCowork: audienceFor(edificiosSeleccionadosCowork, "cowork"),
      audienciaSeleccionadaEspera: audienceFor(edificiosSeleccionadosEspera, "espera"),
      audienciaSeleccionadaTotal,
    };
  }, [
    edificios,
    edificiosSeleccionadosAscensores,
    edificiosSeleccionadosTotems,
    edificiosSeleccionadosCowork,
    edificiosSeleccionadosEspera,
  ]);

  // ===========================================
  // HELPERS
  // ===========================================
  const updateSet = (setter, id, add, hasCircuit) => {
    if (!hasCircuit) return;
    setter((prev) => {
      const next = new Set(prev);
      if (add) {
        next.add(id);
      } else {
        next.delete(id);
      }
      return next;
    });
  };

  function sumarPantallas(edifs) {
    return edifs.reduce((total, edificio) => total + (edificio.pantallas || 0), 0);
  }

  function sumarTotems(edifs) {
    return edifs.reduce((total, edificio) => total + (edificio.totems || 0), 0);
  }

  function sumarCowork(edifs) {
    return edifs.reduce((total, edificio) => total + (edificio.cowork || 0), 0);
  }

  function sumarEspera(edifs) {
    return edifs.reduce((total, edificio) => total + (edificio.espera || 0), 0);
  }

  function sumarTotalPantallas(edificio) {
    return (edificio.pantallas || 0) + (edificio.totems || 0) + (edificio.cowork || 0) + (edificio.espera || 0);
  }

  // Función centralizada para cargar edificios con filtros
  const loadEdificios = useCallback(async () => {
    let newEdificios = await getEdificios({ pais });
    // Excluir edificios con ID 119 y 121
    newEdificios = newEdificios.filter((edificio) => edificio.id !== 119 && edificio.id !== 121);
    const allowedStates = includeInstallingBuildings ? ["OPERATIVO", "INSTALACIÓN", "REACTIVACIÓN"] : ["OPERATIVO"];
    newEdificios = newEdificios.filter((e) => e.estado && allowedStates.includes(e.estado));
    if (isProgrammaticSelected) {
      newEdificios = newEdificios.filter((edificio) => edificio.is_programmatic === true);
    }
    newEdificios.sort((a, b) => (a.edificio || "").localeCompare(b.edificio || ""));
    return newEdificios;
  }, [pais, includeInstallingBuildings, isProgrammaticSelected]);

  // Función para calcular ubicaciones y pantallas por ubicación
  const computeUbicaciones = (edifs) => {
    const uniqueUbicaciones = [...new Set(edifs.map((edificio) => edificio.ubicacion))];
    const pantallasMap = {};
    uniqueUbicaciones.forEach((ubicacion) => {
      pantallasMap[ubicacion] = edifs.reduce(
        (suma, edificio) =>
          edificio.ubicacion === ubicacion
            ? suma +
              (edificio.pantallas || 0) +
              (edificio.totems || 0) +
              (edificio.cowork || 0) +
              (edificio.espera || 0)
            : suma,
        0
      );
    });
    return { uniqueUbicaciones, pantallasMap };
  };

  // ===========================================
  // SINCRONIZACIÓN AL PADRE (único useEffect para onSubmit)
  // ===========================================
  useEffect(() => {
    if (isInitialSyncRef.current) return;

    onSubmit({
      ...derivedCounts,
      edificiosSeleccionadosAscensores: [...edificiosSeleccionadosAscensores],
      edificiosSeleccionadosTotems: [...edificiosSeleccionadosTotems],
      edificiosSeleccionadosCowork: [...edificiosSeleccionadosCowork],
      edificiosSeleccionadosEspera: [...edificiosSeleccionadosEspera],
    });
  }, [derivedCounts]);

  // ===========================================
  // INICIALIZACIÓN
  // ===========================================
  useEffect(() => {
    if (hasInitializedRef.current) return;
    const initialize = async () => {
      const newEdificios = await loadEdificios();
      const { uniqueUbicaciones, pantallasMap } = computeUbicaciones(newEdificios);

      // Determinar si "toda la red" estaba seleccionada
      let selectAllNetworkValue = false;
      let selectInventoryValue =
        defaultEdificiosAscensores?.length > 0 ||
        defaultEdificiosTotems?.length > 0 ||
        defaultEdificiosEspera?.length > 0 ||
        defaultEdificiosCowork?.length > 0;

      if (selectInventoryValue) {
        const allEdificiosIds = new Set(newEdificios.map((e) => String(e.id)));
        const selectedEdificiosSet = new Set(
          [
            ...(defaultEdificiosAscensores || []),
            ...(defaultEdificiosTotems || []),
            ...(defaultEdificiosEspera || []),
            ...(defaultEdificiosCowork || []),
          ].map(String)
        );
        const isAllSelected = [...allEdificiosIds].every((id) => selectedEdificiosSet.has(id));
        if (isAllSelected) {
          selectAllNetworkValue = true;
          selectInventoryValue = false;
        }
      }

      // Establecer estados
      setUbicaciones(uniqueUbicaciones);
      setPantallasPorUbicacionMap(pantallasMap);
      setEdificios(newEdificios);
      setSelectAllNetwork(selectAllNetworkValue);
      setSelectInventory(selectInventoryValue);

      // Calcular payload usando la lista de edificios directamente (derivedCounts aún no está disponible)
      const hasDefaults =
        (defaultEdificiosAscensores?.length || 0) > 0 ||
        (defaultEdificiosTotems?.length || 0) > 0 ||
        (defaultEdificiosEspera?.length || 0) > 0 ||
        (defaultEdificiosCowork?.length || 0) > 0;

      if (hasDefaults) {
        // Calcular conteos iniciales directamente
        const countForInit = (ids, edifs, field) =>
          (ids || []).reduce((total, id) => {
            const edificio = edifs.find((e) => String(e.id) === String(id));
            return edificio ? total + (edificio[field] || 0) : total;
          }, 0);
        const audienceForInit = (ids, edifs, field) =>
          (ids || []).reduce((total, id) => {
            const edificio = edifs.find((e) => String(e.id) === String(id));
            return edificio && (edificio[field] || 0) > 0 ? total + (edificio.personas || 0) : total;
          }, 0);
        const uniqueIds = new Set(
          [
            ...(defaultEdificiosAscensores || []),
            ...(defaultEdificiosTotems || []),
            ...(defaultEdificiosEspera || []),
            ...(defaultEdificiosCowork || []),
          ].map(String)
        );
        const totalAudiencia = [...uniqueIds].reduce((total, id) => {
          const edificio = newEdificios.find((e) => String(e.id) === String(id));
          return edificio ? total + (edificio.personas || 0) : total;
        }, 0);

        onSubmit({
          ascensoresSeleccionados: countForInit(defaultEdificiosAscensores, newEdificios, "pantallas"),
          totemsSeleccionados: countForInit(defaultEdificiosTotems, newEdificios, "totems"),
          coworkSeleccionados: countForInit(defaultEdificiosCowork, newEdificios, "cowork"),
          esperaSeleccionados: countForInit(defaultEdificiosEspera, newEdificios, "espera"),
          audienciaSeleccionadaAscensor: audienceForInit(defaultEdificiosAscensores, newEdificios, "pantallas"),
          audienciaSeleccionadaTotems: audienceForInit(defaultEdificiosTotems, newEdificios, "totems"),
          audienciaSeleccionadaCowork: audienceForInit(defaultEdificiosCowork, newEdificios, "cowork"),
          audienciaSeleccionadaEspera: audienceForInit(defaultEdificiosEspera, newEdificios, "espera"),
          audienciaSeleccionadaTotal: totalAudiencia,
          edificiosSeleccionadosAscensores: [...(defaultEdificiosAscensores || [])],
          edificiosSeleccionadosTotems: [...(defaultEdificiosTotems || [])],
          edificiosSeleccionadosCowork: [...(defaultEdificiosCowork || [])],
          edificiosSeleccionadosEspera: [...(defaultEdificiosEspera || [])],
        });
      } else {
        onSubmit({
          ascensoresSeleccionados: 0,
          totemsSeleccionados: 0,
          coworkSeleccionados: 0,
          esperaSeleccionados: 0,
          audienciaSeleccionadaAscensor: 0,
          audienciaSeleccionadaTotems: 0,
          audienciaSeleccionadaCowork: 0,
          audienciaSeleccionadaEspera: 0,
          audienciaSeleccionadaTotal: 0,
          edificiosSeleccionadosAscensores: [],
          edificiosSeleccionadosTotems: [],
          edificiosSeleccionadosCowork: [],
          edificiosSeleccionadosEspera: [],
        });
      }

      hasInitializedRef.current = true;
      isInitialSyncRef.current = false;
    };
    initialize();
  }, [
    pais,
    rol,
    isProgrammaticSelected,
    includeInstallingBuildings,
    defaultEdificiosAscensores,
    defaultEdificiosTotems,
    defaultEdificiosEspera,
    defaultEdificiosCowork,
  ]);

  // ===========================================
  // RESET
  // ===========================================
  useEffect(() => {
    if (resetInventario) {
      isInitialSyncRef.current = true;
      const resetAndReload = async () => {
        try {
          const newEdificios = await loadEdificios();
          const { uniqueUbicaciones, pantallasMap } = computeUbicaciones(newEdificios);

          setEdificios(newEdificios);
          setEdificiosSeleccionadosAscensores(new Set());
          setEdificiosSeleccionadosTotems(new Set());
          setEdificiosSeleccionadosCowork(new Set());
          setEdificiosSeleccionadosEspera(new Set());
          setSelectAllAscensores(false);
          setSelectAllTotems(false);
          setSelectAllCowork(false);
          setSelectAllEspera(false);
          setSelectAllNetwork(false);
          setSelectInventory(false);
          setUbicacionesSeleccionadas(new Set());
          setUbicaciones(uniqueUbicaciones);
          setPantallasPorUbicacionMap(pantallasMap);

          onSubmit({
            ascensoresSeleccionados: 0,
            totemsSeleccionados: 0,
            coworkSeleccionados: 0,
            esperaSeleccionados: 0,
            audienciaSeleccionadaAscensor: 0,
            audienciaSeleccionadaTotems: 0,
            audienciaSeleccionadaCowork: 0,
            audienciaSeleccionadaEspera: 0,
            audienciaSeleccionadaTotal: 0,
            edificiosSeleccionadosAscensores: [],
            edificiosSeleccionadosTotems: [],
            edificiosSeleccionadosCowork: [],
            edificiosSeleccionadosEspera: [],
          });
        } catch (error) {
          console.error("Error al resetear inventario:", error);
        } finally {
          isInitialSyncRef.current = false;
          onResetComplete();
        }
      };
      resetAndReload();
    }
  }, [resetInventario, pais, rol, isProgrammaticSelected, includeInstallingBuildings, onResetComplete, onSubmit]);

  // ===========================================
  // HANDLERS (solo actualizan Sets — los conteos se derivan automáticamente)
  // ===========================================
  const handleCheckboxChange = (pantallas, isChecked, tipo, personas, id) => {
    if (selectAllNetwork) return;

    const edificio = edificios.find((e) => String(e.id) === String(id));
    if (!edificio) return;

    if (ubicacionesSeleccionadas.has(edificio.ubicacion)) return;

    const idAsString = String(id);

    if (tipo === "edificios") {
      updateSet(setEdificiosSeleccionadosAscensores, idAsString, isChecked, edificio.pantallas > 0);
      updateSet(setEdificiosSeleccionadosTotems, idAsString, isChecked, edificio.totems > 0);
      updateSet(setEdificiosSeleccionadosCowork, idAsString, isChecked, edificio.cowork > 0);
      updateSet(setEdificiosSeleccionadosEspera, idAsString, isChecked, edificio.espera > 0);
    } else if (tipo === "ascensores") {
      updateSet(setEdificiosSeleccionadosAscensores, idAsString, isChecked, edificio.pantallas > 0);
    } else if (tipo === "totems") {
      updateSet(setEdificiosSeleccionadosTotems, idAsString, isChecked, edificio.totems > 0);
    } else if (tipo === "cowork") {
      updateSet(setEdificiosSeleccionadosCowork, idAsString, isChecked, edificio.cowork > 0);
    } else if (tipo === "espera") {
      updateSet(setEdificiosSeleccionadosEspera, idAsString, isChecked, edificio.espera > 0);
    }
  };

  const handleSelectAllChange = (isChecked, tipo, ubicacion = null) => {
    const resetSelections = () => {
      setEdificiosSeleccionadosAscensores(new Set());
      setEdificiosSeleccionadosTotems(new Set());
      setEdificiosSeleccionadosCowork(new Set());
      setEdificiosSeleccionadosEspera(new Set());
      setSelectAllAscensores(false);
      setSelectAllTotems(false);
      setSelectAllCowork(false);
      setSelectAllEspera(false);
      setUbicacionesSeleccionadas(new Set());
    };

    if (tipo === "network") {
      resetSelections();
      setSelectAllNetwork(isChecked);
      setSelectInventory(false);

      if (isChecked) {
        setEdificiosSeleccionadosAscensores(new Set(edificios.filter((e) => e.pantallas > 0).map((e) => String(e.id))));
        setEdificiosSeleccionadosTotems(new Set(edificios.filter((e) => e.totems > 0).map((e) => String(e.id))));
        setEdificiosSeleccionadosCowork(new Set(edificios.filter((e) => e.cowork > 0).map((e) => String(e.id))));
        setEdificiosSeleccionadosEspera(new Set(edificios.filter((e) => e.espera > 0).map((e) => String(e.id))));
      }
    } else if (tipo === "inventory") {
      resetSelections();
      setSelectInventory(isChecked);
      setSelectAllNetwork(false);
    } else if (selectInventory) {
      if (tipo === "ubicacion" && ubicacion) {
        const edificiosDeUbicacion = edificios.filter((edificio) => edificio.ubicacion === ubicacion);
        if (isChecked) {
          setUbicacionesSeleccionadas((prev) => new Set([...prev, ubicacion]));
          edificiosDeUbicacion.forEach((edificio) => {
            const idAsString = String(edificio.id);
            updateSet(setEdificiosSeleccionadosAscensores, idAsString, true, edificio.pantallas > 0);
            updateSet(setEdificiosSeleccionadosTotems, idAsString, true, edificio.totems > 0);
            updateSet(setEdificiosSeleccionadosCowork, idAsString, true, edificio.cowork > 0);
            updateSet(setEdificiosSeleccionadosEspera, idAsString, true, edificio.espera > 0);
          });
        } else {
          setUbicacionesSeleccionadas((prev) => {
            const newSet = new Set(prev);
            newSet.delete(ubicacion);
            return newSet;
          });
          edificiosDeUbicacion.forEach((edificio) => {
            const idAsString = String(edificio.id);
            updateSet(setEdificiosSeleccionadosAscensores, idAsString, false, edificio.pantallas > 0);
            updateSet(setEdificiosSeleccionadosTotems, idAsString, false, edificio.totems > 0);
            updateSet(setEdificiosSeleccionadosCowork, idAsString, false, edificio.cowork > 0);
            updateSet(setEdificiosSeleccionadosEspera, idAsString, false, edificio.espera > 0);
          });
        }
      } else if (tipo === "ascensores") {
        if (isChecked) {
          setEdificiosSeleccionadosAscensores(
            new Set(edificios.filter((e) => e.pantallas > 0).map((e) => String(e.id)))
          );
        } else {
          setEdificiosSeleccionadosAscensores(new Set());
        }
        setSelectAllAscensores(isChecked);
      } else if (tipo === "totems") {
        if (isChecked) {
          setEdificiosSeleccionadosTotems(new Set(edificios.filter((e) => e.totems > 0).map((e) => String(e.id))));
        } else {
          setEdificiosSeleccionadosTotems(new Set());
        }
        setSelectAllTotems(isChecked);
      } else if (tipo === "cowork") {
        if (isChecked) {
          setEdificiosSeleccionadosCowork(new Set(edificios.filter((e) => e.cowork > 0).map((e) => String(e.id))));
        } else {
          setEdificiosSeleccionadosCowork(new Set());
        }
        setSelectAllCowork(isChecked);
      } else if (tipo === "espera") {
        if (isChecked) {
          setEdificiosSeleccionadosEspera(new Set(edificios.filter((e) => e.espera > 0).map((e) => String(e.id))));
        } else {
          setEdificiosSeleccionadosEspera(new Set());
        }
        setSelectAllEspera(isChecked);
      }
    }
  };

  // ===========================================
  // RENDER
  // ===========================================
  return (
    <div className="inventario">
      <p className="tituloinventario">INVENTARIO</p>
      <hr />

      <div className="seleccion">
        <input
          type="checkbox"
          className="cb123"
          checked={selectAllNetwork}
          onChange={(e) => handleSelectAllChange(e.target.checked, "network")}
          data-type="network"
        />
        <span>TODA LA RED</span>
      </div>

      <div className="seleccion">
        <input
          type="checkbox"
          className="cb123"
          checked={selectInventory}
          onChange={(e) => handleSelectAllChange(e.target.checked, "inventory")}
          data-type="inventory"
        />
        <span>SELECCIONAR</span>
      </div>
      <hr />

      {selectInventory && !selectAllNetwork && (
        <>
          <details>
            <summary className="subtitulo">EDIFICIOS</summary>
            <hr />
            {edificios.length > 0 && (
              <div>
                {edificios.map((edificio) => {
                  const tiposDisponibles = [
                    edificio.pantallas > 0 ? "ascensores" : null,
                    edificio.totems > 0 ? "totems" : null,
                    edificio.cowork > 0 ? "cowork" : null,
                    edificio.espera > 0 ? "espera" : null,
                  ].filter(Boolean);

                  const todosSeleccionados = tiposDisponibles.every((tipo) => {
                    if (tipo === "ascensores") return edificiosSeleccionadosAscensores.has(String(edificio.id));
                    if (tipo === "totems") return edificiosSeleccionadosTotems.has(String(edificio.id));
                    if (tipo === "cowork") return edificiosSeleccionadosCowork.has(String(edificio.id));
                    if (tipo === "espera") return edificiosSeleccionadosEspera.has(String(edificio.id));
                    return false;
                  });

                  return (
                    <div key={edificio.id} className="checkbox">
                      <input
                        type="checkbox"
                        style={{ width: "15px", height: "15px", marginRight: "10px" }}
                        checked={todosSeleccionados}
                        onChange={(e) =>
                          handleCheckboxChange(0, e.target.checked, "edificios", edificio.personas, edificio.id)
                        }
                        value={edificio.id}
                        data-type="edificios"
                      />
                      <span>
                        {sumarTotalPantallas(edificio)} | {edificio.edificio.toUpperCase()}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
            {edificios.length === 0 && <p>Cargando edificios...</p>}
          </details>
          <hr />

          <details>
            <summary className="subtitulo">UBICACIÓN</summary>
            <hr />
            {ubicaciones.map((ubicacion, index) => (
              <div key={index} className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={ubicacionesSeleccionadas.has(ubicacion)}
                  onChange={(e) => handleSelectAllChange(e.target.checked, "ubicacion", ubicacion)}
                  data-type="ubicacion"
                />
                <span>
                  {pantallasPorUbicacionMap[ubicacion] || 0} | {ubicacion.toUpperCase()}
                </span>
              </div>
            ))}
          </details>
          <hr />

          <details>
            <summary className="subtitulo">ASCENSORES</summary>
            <hr />
            <div className="checkbox">
              <input
                type="checkbox"
                style={{ width: "15px", height: "15px", marginRight: "10px" }}
                checked={selectAllAscensores}
                onChange={(e) => {
                  const newCheckedState = !selectAllAscensores;
                  setSelectAllAscensores(newCheckedState);
                  handleSelectAllChange(newCheckedState, "ascensores");
                }}
              />
              <span style={{ fontWeight: "bold" }}>{sumarPantallas(edificios)} | SELECCIONAR TODOS</span>
            </div>
            {!selectAllAscensores && edificios.length > 0 && (
              <div>
                {edificios
                  .filter((edificio) => edificio.pantallas > 0)
                  .map((edificio) => (
                    <div key={edificio.id} className="checkbox">
                      <input
                        type="checkbox"
                        style={{ width: "15px", height: "15px", marginRight: "10px" }}
                        checked={edificiosSeleccionadosAscensores.has(String(edificio.id)) || selectAllAscensores}
                        onChange={(e) =>
                          handleCheckboxChange(
                            edificio.pantallas,
                            e.target.checked,
                            "ascensores",
                            edificio.personas,
                            edificio.id
                          )
                        }
                        value={edificio.id}
                        data-type="ascensores"
                      />
                      <span>
                        {edificio.pantallas} | {edificio.edificio.toUpperCase()}
                      </span>
                    </div>
                  ))}
              </div>
            )}
            {edificios.length === 0 && !selectAllAscensores && <p>Cargando edificios...</p>}
          </details>
          <hr />

          {edificios.some((edificio) => edificio.totems > 0) && (
            <details>
              <summary className="subtitulo">CIRCULACIÓN</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllTotems}
                  onChange={(e) => {
                    const newCheckedState = !selectAllTotems;
                    setSelectAllTotems(newCheckedState);
                    handleSelectAllChange(newCheckedState, "totems");
                  }}
                  data-type="totems"
                />
                <span style={{ fontWeight: "bold" }}>{sumarTotems(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllTotems && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.totems > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosTotems.has(String(edificio.id)) || selectAllTotems}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.totems,
                              e.target.checked,
                              "totems",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="totems"
                        />
                        <span>
                          {edificio.totems} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />

          {edificios.some((edificio) => edificio.espera > 0) && (
            <details>
              <summary className="subtitulo">ESPERA</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllEspera}
                  onChange={(e) => {
                    const newCheckedState = !selectAllEspera;
                    setSelectAllEspera(newCheckedState);
                    handleSelectAllChange(newCheckedState, "espera");
                  }}
                  data-type="espera"
                />
                <span style={{ fontWeight: "bold" }}>{sumarEspera(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllEspera && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.espera > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosEspera.has(String(edificio.id)) || selectAllEspera}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.espera,
                              e.target.checked,
                              "espera",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="espera"
                        />
                        <span>
                          {edificio.espera} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />

          {edificios.some((edificio) => edificio.cowork > 0) && (
            <details>
              <summary className="subtitulo">COWORK iF</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllCowork}
                  onChange={(e) => {
                    const newCheckedState = !selectAllCowork;
                    setSelectAllCowork(newCheckedState);
                    handleSelectAllChange(newCheckedState, "cowork");
                  }}
                  data-type="cowork"
                />
                <span style={{ fontWeight: "bold" }}>{sumarCowork(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllCowork && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.cowork > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosCowork.has(String(edificio.id)) || selectAllCowork}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.cowork,
                              e.target.checked,
                              "cowork",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="cowork"
                        />
                        <span>
                          {edificio.cowork} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />
        </>
      )}
    </div>
  );
};
